module.exports = __webpack_public_path__ + "static/media/eres_logo.bf21d8fa.png";